import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyCGzeeY_877TczckLOU1DqVj9GlNf_GOMM",
  authDomain: "finance-tracker-a079b.firebaseapp.com",
  projectId: "finance-tracker-a079b",
  storageBucket: "finance-tracker-a079b.appspot.com",
  messagingSenderId: "338551531114",
  appId: "YOUR_FIREBASE_APP_ID",
};

// init firebase
const app = initializeApp(firebaseConfig);

// init services
const firebaseAuth = getAuth(app);
const firestoreDatabase = getFirestore(app);

// export services
export { firebaseAuth, firestoreDatabase };